module.exports = __webpack_public_path__ + "img/49.0b2621a1.svg";